import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriTrajta, PeremriNumri, PeremriRasa, PeremriVeta } from '@core/enums/peremri/peremri.enum';

@Injectable({
  providedIn: 'root'
})
export class PeremriLidhorFormulaService {

  constructor(private fb: UntypedFormBuilder) { }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, formArray: UntypedFormArray) {
    if (!peremriLlojiParametri) {
      throw new Error('Lloji i përemrit është i zbrazët');
    }

    const ctrls = this.getFormulaControls(peremriLlojiParametri)

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    ctrls.forEach((f) => {
      this.setFormula(formArray, f.numriId, f.rasaId, f.pershkrimi);
    })
  }


  getFormulaControls(
    peremriLlojiParametri: PeremrillojiParametri
  )
    : { numriId: number, rasaId: number, pershkrimi?: string }[] {
    const ctrls: any[] = [];
    switch (peremriLlojiParametri) {
      case PeremrillojiParametri.MashkulloreINyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cili', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilit' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilit', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilin' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilit' })

        ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cilët', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilëve' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilëve', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilët' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilëve' })

        break;
      }

      case PeremrillojiParametri.FemeeroreINyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cila', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilës' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilës', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilën' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilës' })

        ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cilat', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilave' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilave', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilat' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilave' })

        break;
      }

      case PeremrillojiParametri.AsnjaneesINyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cili', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilit' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilit', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilin' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilit' })
        break;
      }

      case PeremrillojiParametri.MashkulloreIPanyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cili', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilit' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilit', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilin' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilit' })

        ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cilët', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilëve' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilëve', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilët' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilëve' })
        break;
      }

      case PeremrillojiParametri.FemeeroreIPanyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cila', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilës' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilës', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilën' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilës' })

        ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cilat', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilave' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilave', }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilat' }),
          ctrls.push({ numriId: PeremriNumri.Shumes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilave' })
        break;
      }

      case PeremrillojiParametri.AsnjaneesIPanyjsheem: {
        ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Emerore, pershkrimi: 'cili', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Gjinore, pershkrimi: 'cilit' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Dhanore, pershkrimi: 'cilit', }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Kallezore, pershkrimi: 'cilin' }),
          ctrls.push({ numriId: PeremriNumri.Njejes, rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'cilit' })
        break;
      }

      case PeremrillojiParametri.Rasee: {
        ctrls.push({ rasaId: PeremriRasa.Emerore, pershkrimi: 'kush', }),
          ctrls.push({ rasaId: PeremriRasa.Gjinore, pershkrimi: 'kujt' }),
          ctrls.push({ rasaId: PeremriRasa.Dhanore, pershkrimi: 'kujt', }),
          ctrls.push({ rasaId: PeremriRasa.Kallezore, pershkrimi: 'kë' }),
          ctrls.push({ rasaId: PeremriRasa.Rrjedhore, pershkrimi: 'kujt' })
        break;
      }


      case PeremrillojiParametri.PaVeccori: {

        break;
      }

    }
    return ctrls;
  }

  private setFormula(formArray: UntypedFormArray, numri: PeremriNumri, rasa: PeremriRasa, value?: string) {
    let fg = formArray.controls.find(
      (c) => c.get('numriId')?.value == numri && c.get('rasaId')?.value == rasa
    ) as UntypedFormGroup;
    if (fg) fg.get('pershkrimi')?.setValue(value);
    else {
      let fg = this.fb.group({
        numriId: numri,
        rasaId: rasa,
        pershkrimi: value,
      });
      if (formArray.disabled) fg.disable();
      formArray.push(fg);
    }
  }
}
